import * as _ from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  importResults: [],
  fetching: false,
  fetchError: undefined,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.IMPORT_RESULT_SAVE_RESULTS:
      return {
        ...state,
        importResults: payload,
      };
    case types.IMPORT_RESULT_SAVE_RESULT:
      var updatedResults = _.cloneDeep(state.importResults);
      updatedResults.push(payload);
      return {
        ...state,
        importResults: updatedResults,
      };
    case types.IMPORT_RESULT_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    case types.IMPORT_RESULT_FETCH_ERROR:
      return {
        ...state,
        fetchError: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/importresult/state/resultgrid/reducer.js